import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [org, setOrg] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    const token = localStorage.getItem("alto_token");
    if (!token) { setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setOrg(data.organization);
      if (data.organization) localStorage.setItem("alto_org", data.organization.id);
    } catch {
      localStorage.removeItem("alto_token");
      localStorage.removeItem("alto_org");
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { refresh(); }, []);

  const applySession = (data) => {
    localStorage.setItem("alto_token", data.token);
    setUser(data.user);
    if (data.user?.active_org_id) localStorage.setItem("alto_org", data.user.active_org_id);
    refresh();
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    applySession(data);
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    applySession(data);
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("alto_token");
    localStorage.removeItem("alto_org");
    setUser(null);
    setOrg(null);
  };

  const switchOrg = async (orgId) => {
    const { data } = await api.post("/auth/switch-org", { org_id: orgId });
    localStorage.setItem("alto_org", data.organization.id);
    await refresh();
    return data;
  };

  return (
    <AuthContext.Provider value={{ user, org, loading, login, register, logout, refresh, switchOrg }}>
      {children}
    </AuthContext.Provider>
  );
}
